/** Arabic date presets — matches Qawaem Console */
export const DATE_PRESET_LABELS = {
  last_year: 'العام الماضي',
  last_month: 'الشهر الماضي',
  yesterday: 'أمس',
  today: 'اليوم',
  tomorrow: 'غداً',
  this_month: 'هذا الشهر',
  this_year: 'هذا العام',
  custom: 'مخصص',
};

export const PRESET_ORDER = [
  'last_year',
  'last_month',
  'yesterday',
  'today',
  'tomorrow',
  'this_month',
  'this_year',
  'custom',
];

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function endOfDay(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

export function getPresetRange(id) {
  const now = new Date();
  const today = startOfDay(now);

  switch (id) {
    case 'today':
      return { start: today, end: endOfDay(new Date(today)) };
    case 'yesterday': {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      return { start: y, end: endOfDay(new Date(y)) };
    }
    case 'tomorrow': {
      const t = new Date(today);
      t.setDate(t.getDate() + 1);
      return { start: t, end: endOfDay(new Date(t)) };
    }
    case 'this_month': {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = endOfDay(new Date(today.getFullYear(), today.getMonth() + 1, 0));
      return { start, end };
    }
    case 'last_month': {
      const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const end = endOfDay(new Date(today.getFullYear(), today.getMonth(), 0));
      return { start, end };
    }
    case 'this_year': {
      const start = new Date(today.getFullYear(), 0, 1);
      const end = endOfDay(new Date(today.getFullYear(), 11, 31));
      return { start, end };
    }
    case 'last_year': {
      const y = today.getFullYear() - 1;
      const start = new Date(y, 0, 1);
      const end = endOfDay(new Date(y, 11, 31));
      return { start, end };
    }
    case 'custom':
    default:
      return { start: null, end: null };
  }
}

function fmtDateShort(d) {
  if (!d) return '';
  try {
    return new Intl.DateTimeFormat('ar-SA', { day: 'numeric', month: 'short', year: 'numeric' }).format(d);
  } catch {
    return d.toLocaleDateString('ar-SA');
  }
}

export function formatRangeLabel(range) {
  if (range?.start && range?.end) {
    return `${fmtDateShort(range.start)} — ${fmtDateShort(range.end)}`;
  }
  return 'كل الفترات';
}

/** True when date falls within header date-range (inclusive). No range => all dates. */
export function isDateInRange(dateInput, range) {
  if (!range?.start && !range?.end) return true;
  if (!dateInput) return false;
  const date = new Date(dateInput);
  if (!Number.isFinite(date.getTime())) return false;
  if (range.start) {
    const start = startOfDay(range.start);
    if (date < start) return false;
  }
  if (range.end) {
    const end = endOfDay(range.end);
    if (date > end) return false;
  }
  return true;
}

/** Approximate month count for treasury/history APIs from a preset range. */
export function monthsCountForRange(range) {
  if (!range?.start || !range?.end) return 12;
  const start = new Date(range.start);
  const end = new Date(range.end);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime())) return 12;
  const count =
    (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
  return Math.min(Math.max(count, 1), 24);
}

export function isMonthKeyInRange(monthKey, range) {
  if (!monthKey) return true;
  const normalized = String(monthKey).length === 7 ? `${monthKey}-01` : monthKey;
  return isDateInRange(normalized, range);
}

/** Day-level trends for short ranges, month buckets otherwise. */
export function analyticsGroupTypeForRange(range) {
  if (!range?.start || !range?.end) return 'month';
  const start = startOfDay(range.start);
  const end = endOfDay(range.end);
  const days = Math.ceil((end - start) / 86400000) + 1;
  return days <= 45 ? 'day' : 'month';
}
